import {z} from 'zod';

const screenId = z.string();

const screenPosition = z.object({
  x: z.number(),
  y: z.number(),
});

export const screenPositions = z.record(screenId, screenPosition);

export type ScreenPositions = z.infer<typeof screenPositions>;
